import { axiosInstance as request } from '@api/rest.service'

const api = stakeholderId => `/stakeholder-responses/${stakeholderId}/subscriptions`

/**
 * @description GET /stakeholder-responses/{id}/subscriptions
 * @returns {AxiosPromise<any>}
 */
export const GET_STAKEHOLDER_RESPONSES = id => request.get(api(id))

/**
 * @description POST /stakeholder-responses/{id}/subscriptions
 * @returns {AxiosPromise<any>}
 */
export const CREATE_STAKEHOLDER_RESPONSE = (id, payload) => request.post(api(id), payload)
